/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChildSocialFeedEntry } from './childSocialFeedEntry';


export interface ApiResponseSocialFeed { 
    feed: Array<ChildSocialFeedEntry>;
    page: number;
    totalCount: number;
    elementsPerBlock: number;
}

